import { Map } from "immutable";
import { createSelector } from "reselect";

const defaultData = Map();

const getAdditionalObjectData = (state, type, id) => {
  return state.additional_object_data.get(`${type}-${id}`, defaultData);
};

export const getObjectHasNewComments = (...attrs) => {
  return getAdditionalObjectData(...attrs).get(`has_new_comments`, false);
};

export const getObjectTotalTime = (...attrs) => {
  return getAdditionalObjectData(...attrs).get(`tracked_time`, 0);
};

export const getObjectTotalExpenses = (...attrs) => {
  return getAdditionalObjectData(...attrs).get(`tracked_expenses`, 0);
};

export const getTasksHasTracking = (state, ids = []) => {
  const tasks = [];
  ids.forEach((id) => {
    tasks.push(state.additional_object_data.get(`Task-${id}`, defaultData));
  });

  if (tasks.some((task) => task.get(`tracked_expenses`, 0) > 0 || task.get(`tracked_time`, 0))) {
    return true;
  }
  return false;
};

export const getObjectDirectlyTrackedTime = (...attrs) => {
  return getAdditionalObjectData(...attrs).get(`time_tracked_directly_on_project`, 0);
};

export const hasStopwatchOffset = (state) => {
  if (!state.additional_object_data) {
    return false;
  }
  const start = state.additional_object_data.get(`stopwatch_request_start`);
  const end = state.additional_object_data.get(`stopwatch_request_end`);
  const offset = state.additional_object_data.get(`stopwatch_offset`);
  if (!start) {
    return false;
  }
  if (!end) {
    return false;
  }
  return offset;
};

export const stopwatchOffset = (state) => {
  if (!state.additional_object_data) {
    return 0;
  }
  const start = state.additional_object_data.get(`stopwatch_request_start`, 0);
  const end = state.additional_object_data.get(`stopwatch_request_end`, 0);
  return end - start + state.additional_object_data.get(`stopwatch_offset`, 0);
};

export const getStopwatchOffset = createSelector(hasStopwatchOffset, stopwatchOffset, (hasOffset, offset) => {
  if (hasOffset && Math.abs(offset) < 10) {
    return 0;
  }
  return hasOffset ? offset : 0;
});
